import React from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { CsvUploadType } from '../../../../../types/csvUploadConfiguration';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { Routing } from '../../../../../util/routes.util';
import { Breadcrumbs, Crumb } from '../../../../components/Breadcrumbs';
import { Tab, Tabs } from '../../../../components/Tabs';
import CsvUploadConfigurationsScreen from '../../../../components/CsvUploadConfiguration/CsvUploadConfigurationsScreen';
import CsvUploadConfigurationUpdatePane from '../../../../components/CsvUploadConfiguration/CsvUploadConfigurationUpdatePane';
import BinStatusOverviewPane from './BinStatus/BinStatusOverviewPane';

export default function BinSettingsScreen() {
  const navigate = useNavigate();

  return (
    <div className='flex flex-grow flex-col'>
      <Breadcrumbs>
        <Crumb path={Routing.stock.bins.overview()} text={t(TranslationKey.bin).plural.upper} />
        <Crumb path={Routing.stock.bins.settings.overview()} text={t(TranslationKey.settings).singular.upper} current />
      </Breadcrumbs>

      <div className='content-y-breadcrumbs flex flex-grow flex-col overflow-hidden'>
        <Tabs padding>
          <Tab
            key={'bin_statuses'}
            text={t(TranslationKey.binStatus).plural.upper}
            path={Routing.stock.bins.settings.binStatuses()}
          />
          <Tab
            key={'import_configurations'}
            text={t(TranslationKey.importConfigurations).singular.upper}
            path={Routing.stock.bins.settings.importConfigurations.overview()}
          />
        </Tabs>
        <div className='flex-grow overflow-hidden'>
          <Routes>
            <Route path={'/*'} element={<Navigate to={Routing.stock.bins.settings.binStatuses()} />} />
            <Route path={'/bin_statuses/*'} element={<BinStatusOverviewPane />} />
            <Route
              path={'/import_configurations/*'}
              element={
                <CsvUploadConfigurationsScreen type={CsvUploadType.bin} backPath={Routing.stock.bins.overview()} />
              }
            />
            <Route
              path={'/import_configurations/update/:id/*'}
              element={
                <CsvUploadConfigurationUpdatePane
                  type={CsvUploadType.bin}
                  onDone={() => navigate(Routing.stock.bins.settings.importConfigurations.overview())}
                />
              }
            />
          </Routes>
        </div>
      </div>
    </div>
  );
}
